
import { defineComponent } from 'vue';
import { BlockItemAction } from "@/models/Blocks/Itens/Types/block-content-types";

export default defineComponent({
    props:{
        action:{
            type: BlockItemAction,
            default: () => new BlockItemAction('', undefined, undefined, undefined)
        },
        className:{
            type: [Object, String],
            default: () => {}
        }
    }
});
